<div class="favorites-items-wrapper">

  @for (item of favoritesItems; track item.id) {

    <app-module-button
      [item]="item"
      (click)="actionButton.emit(item)"
    ></app-module-button>

  }

  @if (showEmptyMessage && favoritesItems.length === 0) {

    <app-empty-widget
      [title]="'ITEMS.MODULES.ADD_FAVORITES' | translate"
      (click)="setFavorites.emit()"
    ></app-empty-widget>

  }

</div>
